"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TdpCapabilityOptions = exports.setTemplateName = exports.ApiAuthOptions = exports.DAMetaOSCapabilityOptions = exports.ActionStartOptions = exports.DACapabilityOptions = exports.NotificationBotOptions = exports.BotCapabilityOptions = exports.OfficeAddinCapabilityOptions = exports.MeArchitectureOptions = exports.MeCapabilityOptions = exports.CustomCopilotAssistantOptions = exports.CustomCopilotRagOptions = exports.CustomCopilotCapabilityOptions = exports.TabCapabilityOptions = exports.CustomEngineAgentOptions = void 0;
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
const templateNames_1 = require("../../../component/generator/templates/templateNames");
const constants_1 = require("../../constants");
const questionNames_1 = require("../../questionNames");
class CustomEngineAgentOptions {
    static basicCustomEngineAgent() {
        return {
            id: "basic-custom-engine-agent",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.basicCustomEngineAgentOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.basicCustomEngineAgentOption.detail"),
            data: templateNames_1.TemplateNames.BasicCustomEngineAgent,
        };
    }
    static weatherAgent() {
        return {
            id: "weather-agent",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.weatherAgentOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.weatherAgentOption.detail"),
            data: templateNames_1.TemplateNames.WeatherAgent,
        };
    }
}
exports.CustomEngineAgentOptions = CustomEngineAgentOptions;
class TabCapabilityOptions {
    static nonSsoTab() {
        return {
            id: "tab-non-sso",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.TabNonSso.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.TabNonSso.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            data: templateNames_1.TemplateNames.Tab,
        };
    }
    static m365SsoLaunchPage() {
        return {
            id: "sso-launch-page",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.M365SsoLaunchPageOptionItem.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.M365SsoLaunchPageOptionItem.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            data: templateNames_1.TemplateNames.SsoTabObo,
        };
    }
    static dashboardTab() {
        return {
            id: "dashboard-tab",
            label: (0, localizeUtils_1.getLocalizedString)("core.DashboardOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.DashboardOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            data: templateNames_1.TemplateNames.DashboardTab,
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.github"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
    }
    // TODO: need further sub-options to decide template name
    static SPFxTab() {
        return {
            id: "tab-spfx",
            label: (0, localizeUtils_1.getLocalizedString)("core.TabSPFxOption.labelNew"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.TabSPFxOption.detailNew"),
        };
    }
}
exports.TabCapabilityOptions = TabCapabilityOptions;
class CustomCopilotCapabilityOptions {
    // custom copilot
    static basicChatbot() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.CEAEnabled)
            ? (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customEngineAgent.description")
            : undefined;
        return {
            id: "custom-copilot-basic",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotBasicOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotBasicOption.detail"),
            description: description,
            data: templateNames_1.TemplateNames.CustomCopilotBasic,
        };
    }
    static customCopilotRag() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.CEAEnabled)
            ? (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customEngineAgent.description")
            : undefined;
        return {
            id: "custom-copilot-rag",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagOption.detail"),
            description: description,
        };
    }
    static aiAgent() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.CEAEnabled)
            ? (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customEngineAgent.description")
            : undefined;
        return {
            id: "custom-copilot-agent",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantOption.detail"),
            description: description,
        };
    }
}
exports.CustomCopilotCapabilityOptions = CustomCopilotCapabilityOptions;
class CustomCopilotRagOptions {
    static customize() {
        return {
            id: "custom-copilot-rag-customize",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagCustomizeOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagCustomizeOption.detail"),
            data: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        };
    }
    static azureAISearch() {
        return {
            id: "custom-copilot-rag-azureAISearch",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagAzureAISearchOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagAzureAISearchOption.detail"),
            data: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        };
    }
    static customApi() {
        return {
            id: "custom-copilot-rag-customApi",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagCustomApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagCustomApiOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
            data: templateNames_1.TemplateNames.CustomCopilotRagCustomApi,
        };
    }
    static microsoft365() {
        return {
            id: "custom-copilot-rag-microsoft365",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagMicrosoft365Option.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagMicrosoft365Option.detail"),
            data: templateNames_1.TemplateNames.CustomCopilotRagMicrosoft365,
        };
    }
}
exports.CustomCopilotRagOptions = CustomCopilotRagOptions;
class CustomCopilotAssistantOptions {
    static new() {
        return {
            id: "custom-copilot-agent-new",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantNewOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantNewOption.detail"),
            data: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        };
    }
    static assistantsApi() {
        return {
            id: "custom-copilot-agent-assistants-api",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantAssistantsApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantAssistantsApiOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
            data: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        };
    }
}
exports.CustomCopilotAssistantOptions = CustomCopilotAssistantOptions;
class MeCapabilityOptions {
    // need further sub-options to decide template name
    static m365SearchMe() {
        return {
            id: "search-app",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.M365SearchAppOptionItem.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.M365SearchAppOptionItem.copilot.detail"),
        };
    }
    static collectFormMe() {
        return {
            id: "collect-form-message-extension",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.labelNew")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.detail"),
            data: templateNames_1.TemplateNames.MessageExtensionAction,
        };
    }
    static linkUnfurling() {
        return {
            id: "link-unfurling",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.LinkUnfurlingOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.LinkUnfurlingOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlook"),
            data: templateNames_1.TemplateNames.LinkUnfurling,
        };
    }
}
exports.MeCapabilityOptions = MeCapabilityOptions;
class MeArchitectureOptions {
    static botMe() {
        return {
            id: "bot",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.botMessageExtension.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.botMessageExtension.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlook"),
            data: templateNames_1.TemplateNames.MessageExtensionM365,
        };
    }
    static newApi() {
        return {
            id: "new-api",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginNewApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.messageExtensionNewApiOption.detail"),
        };
    }
    static openApiSpec() {
        return {
            id: "api-spec",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginApiSpecOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.messageExtensionApiSpecOption.detail"),
            data: templateNames_1.TemplateNames.MessageExtensionWithExistingApiSpec,
        };
    }
}
exports.MeArchitectureOptions = MeArchitectureOptions;
class OfficeAddinCapabilityOptions {
    static outlookAddinImport() {
        return {
            id: "outlook-addin-import",
            label: (0, localizeUtils_1.getLocalizedString)("core.importAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.importAddin.detail"),
            data: templateNames_1.TemplateNames.OfficeAddinCommon,
        };
    }
    static officeContentAddin() {
        return {
            id: "office-content-addin",
            label: (0, localizeUtils_1.getLocalizedString)("core.officeContentAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.officeContentAddin.detail"),
        };
    }
    static officeAddinImport() {
        return {
            id: "office-addin-import",
            label: (0, localizeUtils_1.getLocalizedString)("core.importOfficeAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.importAddin.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.previewOnWindow"),
            data: templateNames_1.TemplateNames.OfficeAddinCommon,
        };
    }
    static outlookTaskPane() {
        return {
            id: "outlook-json-taskpane",
            label: (0, localizeUtils_1.getLocalizedString)("core.newTaskpaneAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.newTaskpaneAddin.detail"),
            data: templateNames_1.TemplateNames.OutlookTaskpane,
        };
    }
    static wxpTaskPane() {
        return {
            id: "wxp-json-taskpane",
            label: (0, localizeUtils_1.getLocalizedString)("core.newTaskpaneAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.newTaskpaneAddin.detail"),
            data: templateNames_1.TemplateNames.WXPTaskpane,
        };
    }
    static DAMetaOS() {
        return {
            id: "office-da-meta-os",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.detail"),
        };
    }
}
exports.OfficeAddinCapabilityOptions = OfficeAddinCapabilityOptions;
class BotCapabilityOptions {
    static basicBot() {
        return {
            id: BotCapabilityOptions.basicBotId,
            label: `${(0, localizeUtils_1.getLocalizedString)("core.BotNewUIOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.BotNewUIOption.detail"),
            data: templateNames_1.TemplateNames.DefaultBot,
        };
    }
    static aiBot() {
        return {
            id: "ai-bot",
            label: (0, localizeUtils_1.getLocalizedString)("core.aiBotOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.aiBotOption.detail"),
            data: templateNames_1.TemplateNames.AIBot,
        };
    }
    // need further sub-options to decide template name
    static notificationBot() {
        return {
            id: BotCapabilityOptions.notificationBotId,
            label: `${(0, localizeUtils_1.getLocalizedString)("core.NotificationOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.NotificationOption.detail"),
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.github"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
    }
    static commandBot() {
        return {
            // id must match cli `yargsHelp`
            id: BotCapabilityOptions.commandBotId,
            label: `${(0, localizeUtils_1.getLocalizedString)("core.CommandAndResponseOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.CommandAndResponseOption.detail"),
            data: templateNames_1.TemplateNames.CommandAndResponse,
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.github"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
    }
    static workflowBot() {
        const item = {
            id: BotCapabilityOptions.workflowBotId,
            label: `${(0, localizeUtils_1.getLocalizedString)("core.WorkflowOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.WorkflowOption.detail"),
            data: templateNames_1.TemplateNames.Workflow,
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.github"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
        return item;
    }
}
exports.BotCapabilityOptions = BotCapabilityOptions;
BotCapabilityOptions.basicBotId = "bot";
BotCapabilityOptions.notificationBotId = "notification";
BotCapabilityOptions.commandBotId = "command-bot";
BotCapabilityOptions.workflowBotId = "workflow-bot";
class NotificationBotOptions {
    static appService() {
        return {
            id: "http-express",
            hostType: constants_1.HostType.AppService,
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.detail"),
            data: templateNames_1.TemplateNames.NotificationExpress,
        };
    }
    static appServiceForVS() {
        return {
            id: "http-webapi",
            hostType: constants_1.HostType.AppService,
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.detail"),
            data: templateNames_1.TemplateNames.NotificationWebApi,
        };
    }
    static functionsTimerTrigger() {
        return {
            id: "timer-functions",
            hostType: constants_1.HostType.Functions,
            triggers: [constants_1.NotificationTriggers.TIMER],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.detail"),
            data: templateNames_1.TemplateNames.NotificationTimerTrigger,
        };
    }
    static functionsHttpAndTimerTrigger() {
        return {
            id: "http-and-timer-functions",
            hostType: constants_1.HostType.Functions,
            triggers: [constants_1.NotificationTriggers.HTTP, constants_1.NotificationTriggers.TIMER],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.detail"),
            data: templateNames_1.TemplateNames.NotificationHttpTimerTrigger,
        };
    }
    static functionsHttpTrigger() {
        return {
            id: "http-functions",
            hostType: constants_1.HostType.Functions,
            triggers: [constants_1.NotificationTriggers.HTTP],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.detail"),
            data: templateNames_1.TemplateNames.NotificationHttpTrigger,
        };
    }
}
exports.NotificationBotOptions = NotificationBotOptions;
class DACapabilityOptions {
    static declarativeAgent() {
        return {
            id: "declarative-agent",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.declarativeAgent.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.declarativeAgent.detail"),
        };
    }
    static noPlugin() {
        return {
            id: "no",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.noPlugin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.noPlugin.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentBasic,
        };
    }
    static withPlugin() {
        return {
            id: "yes",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.addPlugin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.addPlugin.detail"),
        };
    }
    static typeSpec() {
        return {
            id: "type-spec",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiPlugin.typeSpec.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiPlugin.typeSpec.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithTypeSpec,
        };
    }
    static withGC() {
        return {
            id: "gc",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.addGC.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.addGC.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithGraphConnector,
        };
    }
    static all() {
        const items = [
            DACapabilityOptions.noPlugin(),
            DACapabilityOptions.withPlugin(),
            DACapabilityOptions.withGC(),
            DACapabilityOptions.typeSpec(),
        ];
        return items;
    }
}
exports.DACapabilityOptions = DACapabilityOptions;
class ActionStartOptions {
    static newApi() {
        return {
            id: "new-api",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginNewApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginNewApiOption.detail"),
        };
    }
    static apiSpec() {
        return {
            id: "api-spec",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginApiSpecOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginApiSpecOption.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromExistingApiSpec,
        };
    }
    static apiSpecWithSearch() {
        return {
            id: "api-spec",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginApiSpecOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginApiSpecOption.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromExistingApiSpec,
        };
    }
    static DAMetaOS() {
        return {
            id: "da-meta-os",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.DAMetaOS.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.DAMetaOS.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentMetaOSNewProject,
        };
    }
    static existingPlugin() {
        return {
            id: "existing-plugin",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiPlugin.importPlugin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiPlugin.importPlugin.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithExistingAction,
        };
    }
}
exports.ActionStartOptions = ActionStartOptions;
class DAMetaOSCapabilityOptions {
    static newDAMetaOSProject() {
        return {
            id: "da-meta-os-new-project",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.capability.newProject.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.capability.newProject.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentMetaOSNewProject,
        };
    }
    static upgradeExistingProject() {
        return {
            id: "da-meta-os-upgrade-existing-project",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.capability.upgradeProject.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.capability.upgradeProject.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentMetaOSUpgradeProject,
        };
    }
}
exports.DAMetaOSCapabilityOptions = DAMetaOSCapabilityOptions;
class ApiAuthOptions {
    static none(isME = false) {
        return {
            id: "none",
            label: "None",
            data: isME
                ? templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratch
                : templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratch,
        };
    }
    static apiKey() {
        return {
            id: "api-key",
            label: "API Key",
            // TODO: Update the name because the DeclarativeAgentWithActionFromScratchBearer template is currently actually ApiPluginFromScratchAPIKey.
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchBearer,
        };
    }
    static bearerToken() {
        return {
            id: "bearer-token",
            label: "API Key (Bearer Token Auth)",
            data: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingApiKey,
        };
    }
    static microsoftEntra(isME = false) {
        return {
            id: "microsoft-entra",
            label: "Microsoft Entra",
            data: isME
                ? templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingOAuth
                : templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchOAuth,
        };
    }
    static oauth() {
        return {
            id: "oauth",
            label: "OAuth",
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchOAuth,
        };
    }
}
exports.ApiAuthOptions = ApiAuthOptions;
function setTemplateName(selected, inputs) {
    if (selected.data) {
        inputs[questionNames_1.QuestionNames.TemplateName] = selected.data;
    }
}
exports.setTemplateName = setTemplateName;
class TdpCapabilityOptions {
    static me() {
        return {
            id: "message-extension",
            label: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.label"),
            description: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.detail"),
            data: templateNames_1.TemplateNames.MessageExtension,
        };
    }
    static botAndMe() {
        return {
            id: "BotAndMessageExtension",
            label: "",
            data: templateNames_1.TemplateNames.BotAndMessageExtension,
        };
    }
    static nonSsoTabAndBot() {
        return {
            id: "TabNonSsoAndBot",
            label: "",
            data: templateNames_1.TemplateNames.TabAndDefaultBot,
        };
    }
    static nonSsoTab() {
        return {
            id: "tab-non-sso",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.TabNonSso.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.TabNonSso.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            data: templateNames_1.TemplateNames.Tab,
        };
    }
}
exports.TdpCapabilityOptions = TdpCapabilityOptions;
//# sourceMappingURL=CapabilityOptions.js.map